<script lang="ts" setup>
import type { SectionsSeparator } from '@autobid/strapi-integration/rest/components'
import { separator } from '@autobid/ui/utils/cva/separatorCva'
import SectionSeparatorLine from './SeparatorLine.vue'

interface Props {
  data: SectionsSeparator
}

const props = defineProps<Props>()

const { title, titleAlignment, ...separatorLineData } = props.data
</script>

<template>
  <div class="container mx-auto my-2 flex items-center px-3">
    <SectionSeparatorLine
      v-if="titleAlignment && titleAlignment.name !== 'left'"
      :data="separatorLineData"
    />

    <p
      v-if="title?.length"
      class="inline bg-white font-semibold uppercase" :class="[
        separator({
          titleAlignment: titleAlignment?.name,
        }),
      ]"
    >
      {{ title }}
    </p>

    <SectionSeparatorLine
      v-if="titleAlignment?.name !== 'right'"
      :data="separatorLineData"
    />
  </div>
</template>
